/*
* Copyright (c) 2019 Honeywell International, Inc. All rights reserved.
*
* This file contains trade secrets of Honeywell International, Inc.  No part
*  may be reproduced or transmitted in any form by any means or for any
*  purpose without the express written permission of Honeywell.
*
*/
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SiteInfoService {
    getSystemGuid() {
        return sessionStorage.getItem('systemGUID');
    }
}
